import {IApiEndpoints} from "../typings/apiEndpoints";
import {IApiContestant} from "../typings/apiResponse";
import * as angular from "angular";

/**
 * @deprecated since only function of class is deprecated.
 */
export class ContestantResource {
    public static $inject = ["$http", "ApiEndpoints"];
    constructor(private $http:angular.IHttpService,
                private ApiEndpoints:IApiEndpoints) {
    }

    /**
     * @deprecated in favor of LeagueResource::getUserContestantInfos.
     * Multiple contestants in league for user is now supported.
     */
    getContestantInLeague(leagueId:number): angular.IPromise<IApiContestant> {
        return this.$http.get(this.ApiEndpoints.league + '/' + leagueId + '/contestant').then(
            function (response: angular.IHttpPromiseCallbackArg<IApiContestant>) {
                return response.data;
            }
        );
    }
}
